import React, { useState } from "react";
import { Link } from "src/components";
import { Button, Col, Divider, Row, Space, Spin } from "antd";
import { AppstoreAddOutlined } from "@ant-design/icons";

import DeleteView from "src/modules/order/components/DeleteView";
import { EditIcon, RenderTable, Layout, MetaTag } from "src/components";

import { FilterComponent } from "src/modules/order/components";

const ListView: React.FC = (props: any) => {
    const { loading, orders, orderAggregate, loadOrdersData } = props;

    const columns = [
        {
            title: "Name",
            key: "name",
            render: (text, record) => record?.name,
        },
        {
            title: "email",
            key: "email",
            render: (text, record) => record?.email,
        },
        {
            title: "role",
            key: "role",
            render: (text, record) => record?.role,
        },
        {
            title: "Action",
            key: "action",
            align: "right",
            render: (text, record) => (
                <Space size="middle">
                    <Link href={`/order/update/${record?.id}`}>
                        <EditIcon isButton={true} />
                    </Link>
                    <Divider />
                    <DeleteView id={record?.id} isButton={true} />
                </Space>
            ),
        },
    ];

    return (
        <Layout titles={[{ name: "Orders", link: "/order" }]}>
            <MetaTag title="Orders" />
            <Row justify="space-between" align="middle">
                <Col>
                    <h1>Orders List</h1>
                </Col>
                <Col>
                    <Link href={"/order/create"}>
                        <Button type="primary" icon={<AppstoreAddOutlined />}>
                            Add
                        </Button>
                    </Link>
                </Col>
            </Row>
            <hr />

            <FilterComponent isOrder={true} {...props} />
            <hr />

            <Spin spinning={loading}>
                {Boolean(orders?.length) && (
                    <RenderTable
                        loading={loading}
                        columns={columns}
                        data={orders || []}
                        loadData={loadOrdersData}
                        aggregate={orderAggregate?.aggregate?.count}
                    />
                )}
            </Spin>
        </Layout>
    );
};

export default ListView;
